export const clearAuthStorage = () => {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('refreshToken')
  window.localStorage.removeItem('username')
  window.localStorage.removeItem('persist:auth')
}
